import { z } from "zod";

export const deviceCalibrationSchema = z.object({
  deviceId: z.string(),
  rawWeights: z.array(z.number().nullable()),
  calibratedWeights: z.array(z.number().nullable()),
  time: z.coerce.date(),
});

export type DeviceCalibration = z.infer<typeof deviceCalibrationSchema>;
